import { Route } from "react-router-dom";
import { PlanIndexPage, PlanDetailPage } from "../pages/pms/plan";

export const fieldManagerRoutes = (
  <Route path="fm/projects/:id">
    <Route path="project-plan" element={<PlanIndexPage />} />
    <Route path="project-plan/:visitId" element={<PlanDetailPage />} />
  </Route>
);
